import React from 'react';
import { RoomExtra } from 'shared-types/Room';
import { PerDate } from './PerDate';
import { PerTimeRange } from './PerTimeRange';
import { PerDateRange } from './PerDateRange';
import { PerDateTime } from './PerDateTime';
import { PerDateTimeRange } from './PerDateTimeRange';

export const controlTypes = (extra: RoomExtra) =>
  ({
    per_date: <PerDate {...extra} />,
    per_date_time: <PerDateTime {...extra} />,
    per_time_range: <PerTimeRange {...extra} />,
    per_date_range: <PerDateRange {...extra} />,
    per_date_time_range: <PerDateTimeRange {...extra} />,
  }[extra.type] || null);
